import * as React from 'react';
export const chevronLeftSvg = React.forwardRef(function chevronLeftSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.619.381a.875.875 0 0 1 0 1.238L4.237 6l4.382 4.381A.875.875 0 1 1 7.38 11.62l-5-5a.875.875 0 0 1 0-1.238l5-5a.875.875 0 0 1 1.238 0Z',
    }),
  );
});
chevronLeftSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chevronLeft = {
  category: 'icon',
  colorable: true,
  name: 'chevronLeft',
  svg: chevronLeftSvg,
};
